import { render, staticRenderFns } from "./BeforeLogin.vue?vue&type=template&id=63f8316d&scoped=true"
import script from "./BeforeLogin.vue?vue&type=script&lang=js"
export * from "./BeforeLogin.vue?vue&type=script&lang=js"
import style0 from "./BeforeLogin.vue?vue&type=style&index=0&id=63f8316d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8316d",
  null
  
)

export default component.exports